import {
  type ISetOptionParams,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { IPracticeIpWhitelist } from '@principle-theorem/principle-core/interfaces';

interface IIpOverrideForm {
  whitelist: string[];
}

export class UserRestrictionIpOverrideFormGroup extends TypedFormGroup<IIpOverrideForm> {
  constructor() {
    super({ whitelist: new TypedFormControl<string[]>([]) });
  }

  getIpWhitelist(): IPracticeIpWhitelist | undefined {
    const { whitelist } = this.getRawValue();
    return whitelist.length ? { isEnabled: true, whitelist } : undefined;
  }

  setIpWhitelist(
    ipWhitelist?: IPracticeIpWhitelist,
    options?: ISetOptionParams
  ): void {
    this.setValue({ whitelist: ipWhitelist?.whitelist ?? [] }, options);
  }
}
